var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import * as d3flextree from "d3-flextree";
import * as d3hierarchy from "d3-hierarchy";
import { assertNotNull } from "../loader-utils";
//
// Layout a tree
//
// Returns node and edge lists
export function layoutTree(treeData, nodeIds, nodeDimensions, expandedNodes, expandedSubtrees, resizeObserver) {
    var e_1, _a;
    var _b;
    var root = d3hierarchy.hierarchy(treeData.root, function (d) {
        var _a;
        if (expandedSubtrees[nodeIds.get(d)] && d.collapsedChildren) {
            return ((_a = d.children) !== null && _a !== void 0 ? _a : []).concat(d.collapsedChildren);
        }
        return d.children;
    });
    // Layout the tree
    var heighOffset = 60;
    var treelayout = d3flextree
        .flextree()
        .nodeSize(function (d) {
        var id = nodeIds.get(d.data);
        assertNotNull(id);
        var dim = nodeDimensions[id];
        if (dim == undefined ||
            dim.headWidth === undefined ||
            dim.headHeight === undefined ||
            dim.bodyWidth === undefined ||
            dim.bodyHeight === undefined) {
            // This is just a default. We will immediately re-render with the updated actual values.
            return [50, 50];
        }
        if (expandedNodes[id]) {
            return [Math.max(dim.headWidth, dim.bodyWidth) + 20, dim.headHeight + dim.bodyHeight + heighOffset];
        }
        else
            return [dim.headWidth + 20, dim.headHeight + heighOffset];
    })
        .spacing(function (a, b) { return (a.parent === b.parent ? 10 : 40); });
    var layout = treelayout(root);
    var d3nodes = layout.descendants().reverse();
    var d3edges = layout.links();
    // Transform tree representation from d3 into reactflow
    var nodes = d3nodes.map(function (n) {
        return {
            id: nodeIds.get(n.data),
            position: { x: n.x, y: n.y },
            type: "querynode",
            data: __assign(__assign({}, n.data), { resizeObserver: resizeObserver }),
        };
    });
    var edges = d3edges.map(function (e) {
        var sourceId = nodeIds.get(e.source.data);
        var targetId = nodeIds.get(e.target.data);
        var style = {};
        if (e.target.data.edgeWidth) {
            var width = Math.max(1, 10 * Math.min(1, e.target.data.edgeWidth));
            style.strokeWidth = "".concat(width, "px");
        }
        return {
            id: "".concat(sourceId, "->").concat(targetId),
            source: sourceId,
            target: targetId,
            label: e.target.data.edgeLabel,
            className: e.target.data.edgeClass,
            style: style,
            focusable: false,
        };
    });
    // Add crosslinks
    var descendants = root.descendants();
    var map = function (d) {
        return descendants.find(function (h) {
            return h.data === d;
        });
    };
    var crosslinks = [];
    try {
        for (var _c = __values((_b = treeData.crosslinks) !== null && _b !== void 0 ? _b : []), _d = _c.next(); !_d.done; _d = _c.next()) {
            var link = _d.value;
            var sourceNode = map(link.source);
            var targetNode = map(link.target);
            if (!targetNode || !sourceNode)
                continue;
            var sourceId = nodeIds.get(sourceNode.data);
            var targetId = nodeIds.get(targetNode.data);
            crosslinks.push({
                id: "".concat(sourceId, "->").concat(targetId),
                source: sourceId,
                target: targetId,
                className: "qg-crosslink",
                focusable: true,
            });
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return { nodes: nodes, edges: edges.concat(crosslinks) };
}
